


















































import { Component, Vue } from 'vue-property-decorator'
import { getAppList } from '@/api/platform'
import { PlatformProps, DetailsProps } from './index.d'
import OperationModal from './components/operationModal.vue'

@Component({
  name: 'PlatformList',
  components: {
    OperationModal
  }
})
export default class extends Vue {
  private loading = false
  private tableData: PlatformProps[] = []
  private operationDialogFlag = false
  private detail: null | DetailsProps = null

  created() {
    this.onLoad()
  }

  // 获取数据
  private async onLoad() {
    this.loading = true
    const { content } = await getAppList<PlatformProps[]>()
    this.tableData = content
    this.loading = false
  }

  // 弹窗回调
  private onDialogSubmit() {
    this.onLoad()
  }

  // 打开操作弹窗（新增/修改）
  private openOperationDialog(item: null | DetailsProps) {
    if (item) {
      const { id, name, logo, url, identification } = item
      this.detail = { id, name, logo, url, identification }
    } else {
      this.detail = null
    }
    this.operationDialogFlag = true
  }
}
